<template>
  <div class="search-sidebar--single">
    <h3 class="filter--title">{{ $t('general.filter.region') }}</h3>
    <multiselect-region @forceSearch="forceSearch"></multiselect-region>
  </div>
</template>

<script>
import SearchMixin from '@/mixins/searchMixin';
import LodashMixin from '@/mixins/lodash';
import { mapState } from 'vuex';
import MultiselectRegion from '@/components/utils/partials/multiselect-region.vue';

export default {
  mixins: [SearchMixin, LodashMixin],
  components: { MultiselectRegion },
  computed: {
    ...mapState({}),
  },
  data: () => ({}),
  methods: {
    async forceSearch() {
      this.$store
        .dispatch('searchListing/goToSearchPage', {
          router: this.$router,
          params: this.$route.params,
        })
        // Catch error route karena routing ke url yang sama
        .catch(async () => {
          console.log('SAME ROUTE, FORCING SEARCH!');
          this.$store.commit('global/SET_LOADING', true);
          await this.$store.dispatch('searchListing/getSearchListing', {
            query: this.$route.query,
            params: this.$route.params,
          });
          this.$store.commit('global/SET_LOADING', false);
        });
    },
  },
};
</script>
